import { BaseError } from '@webapp/core/utils/errors/BaseError'

type ERRORS =
  | 'ERROR_GETTING_FINANCIAL_ACCOUNT'
  | 'ERROR_GENERATING_CODE_CHALLENGE_OR_VERIFIER'
  | 'ERROR_GETTING_SCA_AUTH_CODE'
  | 'ERROR_INITIALIZING_AIRWALLEX'
  | 'ERROR_RENDERING_AIRWALLEX_SCA_COMPONENT'
  | 'ERROR_GETTING_TRANSFERS_AUTH_CODE'
  | 'MOUNT_ELEMENT_NOT_FOUND'
  | 'ERROR_RENDERING_AIRWALLEX_BENEFICIARY_FORM'

export class BankingUseCaseErrors extends BaseError<ERRORS> {}
